import { DefaultCustomItemOptions } from '@/components/documents/CustomItems/DefaultCustomItemOptions'
import { PbProductType } from '@/enums/PbProductType'
import { PbSubcategory } from '@/enums/PbSubcategory'

export const WisconsinCustomItems = {
	...DefaultCustomItemOptions,
	[PbProductType.Service]: {
		[PbSubcategory.ServiceBasicServicesOfFDAndStaff]: [],
		[PbSubcategory.ServiceEmbalming]: [],
		[PbSubcategory.ServiceRefrigeration]: [],
		[PbSubcategory.ServiceOtherBodyPreparation]: [],
		[PbSubcategory.ServiceVisitationViewing]: [],
		[PbSubcategory.ServiceFuneralMemorial]: [],
		[PbSubcategory.ServiceGravesideService]: [],
		[PbSubcategory.ServiceCremationService]: [],
		[PbSubcategory.ServiceForwardingRemains]: [],
		[PbSubcategory.ServiceReceivingRemains]: [],
		[PbSubcategory.ServiceHairdresser]: [],
		[PbSubcategory.Discount]: [],
		[PbSubcategory.Other2]: [],
		[PbSubcategory.Other]: [],
		[PbSubcategory.ServiceOtherFacilities]: [],
	},
	[PbProductType.Transportation]: {
		[PbSubcategory.TransportationTransfer]: [
			{
				prop: 'mileRadiusForStandardService',
				label: 'Mile Radius for Standard Service',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.TransportationHearse]: [
			{
				prop: 'mileRadiusForStandardService',
				label: 'Mile Radius for Standard Service',
				type: 'text',
				required: false,
			},
			{
				prop: 'specificMileAllotment',
				label: 'Specific Mile Allotment',
				type: 'text',
				required: false,
			},
			{
				prop: 'amountPerMile',
				label: 'Amount Per Mile',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.TransportationFamilyCarLimo]: [],
		[PbSubcategory.TransportationUtilityVehicleVan]: [],
		[PbSubcategory.Other]: [],
		[PbSubcategory.Other2]: [],
	},
	[PbProductType.Merchandise]: {
		[PbSubcategory.MerchandiseCasket]: [
			{
				prop: 'productManufacturer',
				label: 'Product Manufacturer',
				type: 'text',
				required: false,
			},
			{
				prop: 'modelNameNumber',
				label: 'Model Name/Number',
				type: 'text',
				required: false,
			},
			{
				prop: 'exteriorDescription',
				label: 'Exterior Description',
				type: 'text',
				required: false,
			},
			{
				prop: 'interiorDescription',
				label: 'Interior Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.MerchandiseOuterBurialContainer]: [
			{
				prop: 'productManufacturer',
				label: 'Product Manufacturer',
				type: 'text',
				required: false,
			},
			{
				prop: 'modelNameNumber',
				label: 'Model Name/Number',
				type: 'text',
				required: false,
			},
			{
				prop: 'exteriorDescription',
				label: 'Exterior Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.MerchandiseUrn]: [
			{
				prop: 'productManufacturer',
				label: 'Product Manufacturer',
				type: 'text',
				required: false,
			},
			{
				prop: 'modelNameNumber',
				label: 'Model Name/Number',
				type: 'text',
				required: false,
			},
			{
				prop: 'exteriorDescription',
				label: 'Exterior Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.MerchandiseMemorialBook]: [],
		[PbSubcategory.MerchandiseMemorialFolders]: [],
		[PbSubcategory.MerchandiseAckCards]: [],
		[PbSubcategory.MerchandiseClothing]: [],
		[PbSubcategory.Discount]: [],
		[PbSubcategory.Other]: [],
		[PbSubcategory.Other2]: [],
	},
	[PbProductType.CashAdvance]: {
		[PbSubcategory.CashAdvanceDeathCertificates]: [
			{ prop: 'quantity', label: 'Quantity', type: 'text', required: false },
			{
				prop: 'amountPerDeathCertificate',
				label: 'Amount Per Death Certificate',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.CashAdvanceObituary]: [],
		[PbSubcategory.CashAdvanceFlowers]: [
			{
				prop: 'flowersType',
				label: 'Flowers Type',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.CashAdvanceHairdresser]: [],
		[PbSubcategory.CashAdvanceClothing]: [],
		[PbSubcategory.CashAdvanceClergyHonorarium]: [],
		[PbSubcategory.CashAdvanceMusicianVocalist]: [],
		[PbSubcategory.CashAdvanceMusic]: [],
		[PbSubcategory.CashAdvanceCremationServices]: [],
		[PbSubcategory.Discount]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Other]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Other2]: [],
	},
}
